var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPj3PlacePo = function SvgPj3PlacePo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Pj3PlacePO_svg__a)",
    stroke: "current",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5.5v7.333a1.833 1.833 0 0 0 1.833 1.834h7.334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 31.167H20.167A3.667 3.667 0 0 1 16.5 27.5V9.167A3.667 3.667 0 0 1 20.167 5.5H27.5l9.167 9.167V27.5A3.666 3.666 0 0 1 33 31.167Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.333 31.167v3.666a3.667 3.667 0 0 1-3.666 3.667H12.833a3.667 3.667 0 0 1-3.666-3.667V16.5a3.667 3.667 0 0 1 3.666-3.667H16.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Pj3PlacePO_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};

export default SvgPj3PlacePo;